import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    alert: {
      show: false,
      msg: null,
      color: 'primary'
    },
    token: null,
    user: null
  },
  mutations: {
    SET_ALERT: (state, newValue) => {
      state.alert = newValue
    },
    SET_TOKEN: (state, newValue) => {
      state.token = newValue
    },
    SET_USER: (state, newValue) => {
      state.user = newValue
    }
  },
  actions: {
    setAlert: ({ commit, state }, newValue) => {
      commit('SET_ALERT', newValue)
      return state.alert
    },
    setToken: ({ commit, state }, newValue) => {
      commit('SET_TOKEN', newValue)
      return state.token
    },
    setUser: ({ commit, state }, newValue) => {
      commit('SET_USER', newValue)
      return state.user
    }
  },
  modules: {
  },
  plugins: [createPersistedState({
    paths: ['user', 'token']
  })]
})
